"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const styles_1 = __importDefault(require("../../styles/styles"));
const modalStyles_1 = __importDefault(require("./modalStyles"));
const themes_1 = __importDefault(require("../../styles/themes"));
const defaultProps = {
    theme: themes_1.default.modal,
    containerStyle: {},
};
const Modal = ({ children, title, visible, hideModal, theme, containerStyle }) => {
    const close = () => react_1.default.createElement(react_native_paper_1.IconButton, { icon: "close", size: 20, onPress: () => hideModal() });
    return (react_1.default.createElement(react_native_paper_1.Portal, null,
        react_1.default.createElement(react_native_paper_1.Modal, { visible: visible, dismissable: false, contentContainerStyle: styles_1.default.flexOne, theme: theme },
            react_1.default.createElement(react_native_1.View, { style: [modalStyles_1.default.modalView, containerStyle] },
                react_1.default.createElement(react_native_paper_1.Card, { style: [styles_1.default.whiteBackground] },
                    react_1.default.createElement(react_native_paper_1.Card.Title, { title: title, right: close, titleStyle: styles_1.default.textColorBlack }),
                    react_1.default.createElement(react_native_paper_1.Card.Content, null, children))))));
};
Modal.defaultProps = defaultProps;
exports.default = Modal;
